exports.Routes = {
  Page404: (query) => ({ pathname: "/404", query }),
  About: (query) => ({ pathname: "/about", query }),
  ArticlePage: (query) => ({ pathname: "/articles/[...slugAndPage]", query }),
  BrandPage: (query) => ({ pathname: "/brands/[slug]", query }),
  CategoryPage: (query) => ({ pathname: "/categories/[[...slugPathAndPage]]", query }),
  Contact: (query) => ({ pathname: "/contact", query }),
  Home: (query) => ({ pathname: "/", query }),
  PrivacyPolicy: (query) => ({ pathname: "/privacy-policy", query }),
  Search: (query) => ({ pathname: "/search/[q]", query }),
  Sitemap: (query) => ({ pathname: "/sitemap.xml", query }),
  TermsOfUse: (query) => ({ pathname: "/terms-of-use", query })
}